import {Tooltip} from "bootstrap";
import PageLoadedQueue
    from "LocalPackages/Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/PageLoadedQueue";

export function initCmsTooltip(element: HTMLElement) {
    const tooltip = new Tooltip(element, {
        trigger: 'manual',
        placement: 'top',
        title: element.dataset.bsTitle || element.title,
        delay: {show: 500, hide: 100},
    });

    const trigger = (element.dataset.cmsTrigger || 'click').split(',');

    if (trigger.includes('hover')) {
        element.addEventListener('mouseenter', () => {
            tooltip.show();
        });

        element.addEventListener('mouseleave', () => {
            tooltip.hide();
        });

        element.addEventListener('touchstart', () => {
            tooltip.show();
        });
    }

    if (trigger.includes('click')) {
        element.addEventListener('click', () => {
            tooltip.show();
        });
    }
}

export function initAllCmsTooltips() {
    document.querySelectorAll('[data-cms-toggle="tooltip"]').forEach((element: HTMLElement) => {
        initCmsTooltip(element);
    });
}

PageLoadedQueue.addFunction(initAllCmsTooltips);
